<template>
  <footer class="bg-primary-3 text-white links-white pb-4">
    <div class="container">
      <div
        class="row flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-between text-center text-lg-left">
        <div class="col-auto">
          <div class="d-flex flex-column flex-sm-row align-items-center text-small">
            <div class="text-muted">&copy; 2019 Page protected by reCAPTCHA and subject to Google's <a
                href="https://www.google.com/policies/privacy/" target="_blank">Privacy Policy</a> and <a
                href="https://policies.google.com/terms" target="_blank">Terms of Service</a>
            </div>
          </div>
        </div>
        <div class="col-auto mt-3 mt-lg-0">
          <ul class="list-unstyled d-flex mb-0">
            <li class="mx-3">
              <a href="#" class="hover-fade-out">
                <img src="assets/img/icons/social/dribbble.svg" alt="Dribbble" class="icon icon-xs bg-white"
                  data-inject-svg>
              </a>
            </li>
            <li class="mx-3">
              <a href="#" class="hover-fade-out">
                <img src="assets/img/icons/social/twitter.svg" alt="Twitter" class="icon icon-xs bg-white"
                  data-inject-svg>
              </a>
            </li>
            <li class="mx-3">
              <a href="#" class="hover-fade-out">
                <img src="assets/img/icons/social/github.svg" alt="Github" class="icon icon-xs bg-white"
                  data-inject-svg>
              </a>
            </li>
            <li class="mx-3">
              <a href="#" class="hover-fade-out">
                <img src="assets/img/icons/social/facebook.svg" alt="Facebook" class="icon icon-xs bg-white"
                  data-inject-svg>
              </a>
            </li>
            <li class="mx-3">
              <a href="#" class="hover-fade-out">
                <img src="assets/img/icons/social/google.svg" alt="Google" class="icon icon-xs bg-white"
                  data-inject-svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'FooterSection'
}
</script>